export default __webpack_public_path__ + "static/media/Mulish-ExtraBold.7db7bade.ttf";